import constants from '../../config/constants'

import parseFlightId from '../../utils/parseFlightId'
import { dateToBackEndFormat } from '../../utils/dates'
import customTourOperatorParameters from '../../utils/tourOperators/customTourOperatorParameters'

export const flightNumber = (flightId: string) => parseFlightId(flightId).number
export const departureDate = (flightId: string) =>
  dateToBackEndFormat(
    parseFlightId(flightId).date,
    constants.frontEndDateFormat
  )
    .split('-')
    .join('')

export const route = (flightId: string) => {
  const parsedFlightId = parseFlightId(flightId)

  return `${parsedFlightId.departure}-${parsedFlightId.arrival}`
}

export const tourOperatorCode = () => {
  const customTopCode: any = customTourOperatorParameters()

  return customTopCode.tourOperatorCode
}

export default {
  flightNumber,
  departureDate,
  route,
  tourOperatorCode,
}
